import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const fetchTestAccept = async () => {
  loaderService.show();
  try {
    const response = await apiService.get(
      'insights/admin/solicitud/prueba/?tipo=solicitudes',
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const putAcceptTest = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.put(
      'insights/admin/solicitud/prueba/',
      params,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const putRejectTest = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.put(
      'insights/admin/solicitud/prueba/',
      params,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const getTestProgress = async () => {
  loaderService.show();
  try {
    const response = await apiService.get(
      'insights/admin/solicitud/prueba/?tipo=enCurso',
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const postTestResults = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.post(
      'insights/admin/solicitud/prueba/',
      params,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

export {
  fetchTestAccept, putAcceptTest, putRejectTest, getTestProgress, postTestResults,
};
